export function useTipsterDisplay(tipsterName: string) {
  if (tipsterName.toLowerCase().endsWith('s')) {
    return `${tipsterName}'`
  }
  return `${tipsterName}'s`
}
